import { styled } from "styled-components";

export const Text = styled.div`
  font-size: 18px;
  font-weight: 600;
  margin-left: 10px;
  margin-right: 5px;
`;
